export const currentUser = () => {
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.user) {
        return  user.user;
    } else {
        return {};
    }
    
};